// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const ArenaMatchmakingLobbyPlayerRow = __t.object("ArenaMatchmakingLobbyPlayerRow", {
  playerId: __t.string(),
  lobbyId: __t.string(),
  team: __t.u32(),
  playerName: __t.string(),
  generalArchetype: __t.string(),
  unitArchetypes: __t.string(),
  joinedAt: __t.timestamp(),
});
export type ArenaMatchmakingLobbyPlayerRow = __Infer<typeof ArenaMatchmakingLobbyPlayerRow>;

export const ArenaMatchmakingLobbyRow = __t.object("ArenaMatchmakingLobbyRow", {
  lobbyId: __t.string(),
  timerScheduledAt: __t.option(__t.timestamp()),
  createdAt: __t.timestamp(),
  matchId: __t.option(__t.string()),
});
export type ArenaMatchmakingLobbyRow = __Infer<typeof ArenaMatchmakingLobbyRow>;

export const ArenaMatchmakingQueueRow = __t.object("ArenaMatchmakingQueueRow", {
  playerId: __t.string(),
  playerName: __t.string(),
  generalArchetype: __t.string(),
  unitArchetypes: __t.string(),
  queuedAt: __t.timestamp(),
});
export type ArenaMatchmakingQueueRow = __Infer<typeof ArenaMatchmakingQueueRow>;

export const ArenaMatchmakingTimerScheduleRow = __t.object("ArenaMatchmakingTimerScheduleRow", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  lobbyId: __t.string(),
});
export type ArenaMatchmakingTimerScheduleRow = __Infer<typeof ArenaMatchmakingTimerScheduleRow>;

export const ArmyFormationRow = __t.object("ArmyFormationRow", {
  id: __t.string(),
  armyId: __t.string(),
  name: __t.string(),
  slots: __t.string(),
  createdAt: __t.timestamp(),
});
export type ArmyFormationRow = __Infer<typeof ArmyFormationRow>;

export const ArmyGroupRow = __t.object("ArmyGroupRow", {
  id: __t.string(),
  armyId: __t.string(),
  groupNumber: __t.u32(),
  name: __t.string(),
  unitIds: __t.string(),
});
export type ArmyGroupRow = __Infer<typeof ArmyGroupRow>;

export const ArmyRow = __t.object("ArmyRow", {
  id: __t.string(),
  playerId: __t.string(),
  name: __t.string(),
  marchOrder: __t.string(),
  createdAt: __t.timestamp(),
});
export type ArmyRow = __Infer<typeof ArmyRow>;

export const ArmyUnitRow = __t.object("ArmyUnitRow", {
  id: __t.string(),
  armyId: __t.string(),
  archetype: __t.string(),
  customName: __t.string(),
  slotIndex: __t.u32(),
  isGeneral: __t.bool(),
  level: __t.u32(),
  experience: __t.u32(),
  troopsPercent: __t.f64(),
  kills: __t.u32(),
  battlesSurvived: __t.u32(),
  skills: __t.string(),
});
export type ArmyUnitRow = __Infer<typeof ArmyUnitRow>;

export const AuthCacheRow = __t.object("AuthCacheRow", {
  identity: __t.identity(),
  userId: __t.string(),
  username: __t.string(),
  tier: __t.string(),
  authenticatedAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type AuthCacheRow = __Infer<typeof AuthCacheRow>;

export const CampaignArmyRow = __t.object("CampaignArmyRow", {
  id: __t.string(),
  playerId: __t.string(),
  worldId: __t.string(),
  persistentArmyId: __t.string(),
  name: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  destinationX: __t.option(__t.f64()),
  destinationY: __t.option(__t.f64()),
  status: __t.string(),
  currentCityId: __t.option(__t.string()),
  activeBattleId: __t.option(__t.string()),
  speedPerSecond: __t.f64(),
  updatedAt: __t.timestamp(),
});
export type CampaignArmyRow = __Infer<typeof CampaignArmyRow>;

export const CampaignBattleRow = __t.object("CampaignBattleRow", {
  id: __t.string(),
  worldId: __t.string(),
  matchId: __t.option(__t.string()),
  attackerArmyId: __t.string(),
  defenderArmyId: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  status: __t.string(),
  createdAt: __t.timestamp(),
  resolvedAt: __t.option(__t.timestamp()),
});
export type CampaignBattleRow = __Infer<typeof CampaignBattleRow>;

export const CampaignCityRow = __t.object("CampaignCityRow", {
  id: __t.string(),
  worldId: __t.string(),
  structureIndex: __t.u32(),
  name: __t.string(),
  tier: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  radius: __t.f64(),
  ownerPlayerId: __t.option(__t.string()),
  goldPerTick: __t.u32(),
  manpowerPerTick: __t.u32(),
  suppliesPerTick: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type CampaignCityRow = __Infer<typeof CampaignCityRow>;

export const CampaignEventRow = __t.object("CampaignEventRow", {
  rowId: __t.u64(),
  worldId: __t.string(),
  tick: __t.u64(),
  eventType: __t.string(),
  playerId: __t.option(__t.string()),
  armyId: __t.option(__t.string()),
  cityId: __t.option(__t.string()),
  battleId: __t.option(__t.string()),
  message: __t.string(),
  createdAt: __t.timestamp(),
});
export type CampaignEventRow = __Infer<typeof CampaignEventRow>;

export const CampaignPlayerRow = __t.object("CampaignPlayerRow", {
  playerId: __t.string(),
  worldId: __t.string(),
  playerName: __t.string(),
  joinedAt: __t.timestamp(),
  lastSeenAt: __t.timestamp(),
});
export type CampaignPlayerRow = __Infer<typeof CampaignPlayerRow>;

export const CampaignRecruitmentQueueRow = __t.object("CampaignRecruitmentQueueRow", {
  rowId: __t.u64(),
  playerId: __t.string(),
  worldId: __t.string(),
  cityId: __t.string(),
  armyId: __t.string(),
  archetype: __t.string(),
  count: __t.u32(),
  ticksRemaining: __t.u32(),
  status: __t.string(),
  createdAt: __t.timestamp(),
});
export type CampaignRecruitmentQueueRow = __Infer<typeof CampaignRecruitmentQueueRow>;

export const CampaignResourcePoolRow = __t.object("CampaignResourcePoolRow", {
  playerId: __t.string(),
  worldId: __t.string(),
  gold: __t.u32(),
  manpower: __t.u32(),
  supplies: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type CampaignResourcePoolRow = __Infer<typeof CampaignResourcePoolRow>;

export const CampaignTickScheduleRow = __t.object("CampaignTickScheduleRow", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  worldId: __t.string(),
});
export type CampaignTickScheduleRow = __Infer<typeof CampaignTickScheduleRow>;

export const CampaignWorldRow = __t.object("CampaignWorldRow", {
  id: __t.string(),
  mapName: __t.string(),
  phase: __t.string(),
  tick: __t.u64(),
  width: __t.f64(),
  height: __t.f64(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type CampaignWorldRow = __Infer<typeof CampaignWorldRow>;

export const ConnectionRow = __t.object("ConnectionRow", {
  identity: __t.identity(),
  playerId: __t.string(),
  userId: __t.option(__t.string()),
  playerName: __t.string(),
  connectedAt: __t.timestamp(),
});
export type ConnectionRow = __Infer<typeof ConnectionRow>;

export const ConquestChallengeRow = __t.object("ConquestChallengeRow", {
  id: __t.string(),
  ruleset: __t.string(),
  territoryId: __t.string(),
  challengerPlayerId: __t.string(),
  defenderPlayerId: __t.string(),
  status: __t.string(),
  sourceMatchId: __t.option(__t.string()),
  challengeMatchId: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  resolvedAt: __t.option(__t.timestamp()),
});
export type ConquestChallengeRow = __Infer<typeof ConquestChallengeRow>;

export const ConquestCustomUnitTemplateRow = __t.object("ConquestCustomUnitTemplateRow", {
  id: __t.string(),
  playerId: __t.string(),
  ruleset: __t.string(),
  culture: __t.string(),
  displayName: __t.string(),
  meleeWeapon: __t.string(),
  shield: __t.string(),
  armor: __t.string(),
  rangedWeapon: __t.string(),
  mount: __t.string(),
  training: __t.string(),
  weaponTrainingRank: __t.u32(),
  shieldTrainingRank: __t.u32(),
  formationTrainingRank: __t.u32(),
  enduranceTrainingRank: __t.u32(),
  skirmishingTrainingRank: __t.u32(),
  horsemanshipTrainingRank: __t.u32(),
  fieldcraftTrainingRank: __t.u32(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type ConquestCustomUnitTemplateRow = __Infer<typeof ConquestCustomUnitTemplateRow>;

export const ConquestEventRow = __t.object("ConquestEventRow", {
  rowId: __t.u64(),
  playerId: __t.string(),
  ruleset: __t.string(),
  eventType: __t.string(),
  territoryId: __t.option(__t.string()),
  challengeId: __t.option(__t.string()),
  matchId: __t.option(__t.string()),
  message: __t.string(),
  createdAt: __t.timestamp(),
});
export type ConquestEventRow = __Infer<typeof ConquestEventRow>;

export const ConquestLobbyTimerRow = __t.object("ConquestLobbyTimerRow", {
  matchId: __t.string(),
  phase: __t.string(),
  buildRemainingMicros: __t.u64(),
  buildLastStartedAt: __t.option(__t.timestamp()),
  startRemainingMicros: __t.u64(),
  startLastStartedAt: __t.option(__t.timestamp()),
  startLocked: __t.bool(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type ConquestLobbyTimerRow = __Infer<typeof ConquestLobbyTimerRow>;

export const ConquestLobbyTimerScheduleRow = __t.object("ConquestLobbyTimerScheduleRow", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  matchId: __t.string(),
});
export type ConquestLobbyTimerScheduleRow = __Infer<typeof ConquestLobbyTimerScheduleRow>;

export const ConquestMatchmakingQueueRow = __t.object("ConquestMatchmakingQueueRow", {
  rowId: __t.u64(),
  playerId: __t.string(),
  ruleset: __t.string(),
  territoryId: __t.string(),
  status: __t.string(),
  matchedMatchId: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type ConquestMatchmakingQueueRow = __Infer<typeof ConquestMatchmakingQueueRow>;

export const ConquestProfileRow = __t.object("ConquestProfileRow", {
  id: __t.string(),
  playerId: __t.string(),
  ruleset: __t.string(),
  playerName: __t.string(),
  avatarName: __t.string(),
  avatarStatus: __t.string(),
  selectedStarterTerritoryId: __t.option(__t.string()),
  controlledTerritoryCount: __t.u32(),
  replenishmentRate: __t.f64(),
  unlockedUnitsJson: __t.string(),
  unlockedTechJson: __t.string(),
  culture: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  armyBannerId: __t.option(__t.string()),
  armyColor: __t.option(__t.string()),
  armyMarkerTerritoryId: __t.option(__t.string()),
  armyMarkerX: __t.option(__t.f64()),
  armyMarkerY: __t.option(__t.f64()),
});
export type ConquestProfileRow = __Infer<typeof ConquestProfileRow>;

export const ConquestSavedUnitRow = __t.object("ConquestSavedUnitRow", {
  id: __t.string(),
  playerId: __t.string(),
  ruleset: __t.string(),
  archetype: __t.string(),
  customName: __t.option(__t.string()),
  level: __t.u32(),
  experience: __t.u32(),
  troopsPercent: __t.f64(),
  kills: __t.u32(),
  battlesSurvived: __t.u32(),
  skillsJson: __t.string(),
});
export type ConquestSavedUnitRow = __Infer<typeof ConquestSavedUnitRow>;

export const ConquestTerritoryRow = __t.object("ConquestTerritoryRow", {
  id: __t.string(),
  playerId: __t.string(),
  ruleset: __t.string(),
  territoryId: __t.string(),
  name: __t.string(),
  status: __t.string(),
  controlled: __t.bool(),
  isStarter: __t.bool(),
  tier: __t.u32(),
  x: __t.f64(),
  y: __t.f64(),
  battleMapsJson: __t.string(),
  unlockUnitsJson: __t.string(),
  unlockTechJson: __t.string(),
  updatedAt: __t.timestamp(),
});
export type ConquestTerritoryRow = __Infer<typeof ConquestTerritoryRow>;

export const LobbyCleanupScheduleRow = __t.object("LobbyCleanupScheduleRow", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type LobbyCleanupScheduleRow = __Infer<typeof LobbyCleanupScheduleRow>;

export const MapDataRow = __t.object("MapDataRow", {
  name: __t.string(),
  mapJson: __t.string(),
  isActive: __t.bool(),
});
export type MapDataRow = __Infer<typeof MapDataRow>;

export const MapUploadBufferRow = __t.object("MapUploadBufferRow", {
  name: __t.string(),
  receivedChunks: __t.u32(),
  totalChunks: __t.u32(),
  data: __t.string(),
});
export type MapUploadBufferRow = __Infer<typeof MapUploadBufferRow>;

export const MatchAntGroupsRow = __t.object("MatchAntGroupsRow", {
  matchId: __t.string(),
  groupsJson: __t.string(),
  updatedTick: __t.u32(),
});
export type MatchAntGroupsRow = __Infer<typeof MatchAntGroupsRow>;

export const MatchArmyRow = __t.object("MatchArmyRow", {
  rowId: __t.u64(),
  matchId: __t.string(),
  armyIndex: __t.u32(),
  team: __t.u32(),
  name: __t.string(),
  claimedPlayerId: __t.string(),
  playerId: __t.option(__t.string()),
  playerName: __t.string(),
  color: __t.string(),
  culture: __t.string(),
  persistentArmyId: __t.option(__t.string()),
  rosterSelected: __t.bool(),
  deployed: __t.bool(),
  ready: __t.bool(),
  defeated: __t.bool(),
  commanderId: __t.option(__t.string()),
  generalId: __t.option(__t.string()),
  followActive: __t.bool(),
  followPathJson: __t.string(),
  followSpeed: __t.f64(),
  followPathTotalDist: __t.f64(),
  marchOrderJson: __t.string(),
  isBot: __t.bool(),
});
export type MatchArmyRow = __Infer<typeof MatchArmyRow>;

export const MatchCampRow = __t.object("MatchCampRow", {
  campId: __t.string(),
  matchId: __t.string(),
  armyIndex: __t.u32(),
  generalUnitId: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  radius: __t.f64(),
  hp: __t.f64(),
  maxHp: __t.f64(),
  tentCount: __t.u32(),
  maxTents: __t.u32(),
  tentsJson: __t.string(),
  placedTick: __t.u32(),
  completed: __t.bool(),
  constructionProgress: __t.f64(),
  constructionRequired: __t.f64(),
});
export type MatchCampRow = __Infer<typeof MatchCampRow>;

export const MatchCapturePointRow = __t.object("MatchCapturePointRow", {
  capturePointId: __t.string(),
  matchId: __t.string(),
  structureIndex: __t.u32(),
  owner: __t.option(__t.u32()),
  progress: __t.f64(),
  capturingTeam: __t.option(__t.u32()),
  holdCounter: __t.u32(),
});
export type MatchCapturePointRow = __Infer<typeof MatchCapturePointRow>;

export const MatchCheckpointRow = __t.object("MatchCheckpointRow", {
  matchId: __t.string(),
  tick: __t.u64(),
  stateBlob: __t.string(),
  savedAt: __t.timestamp(),
});
export type MatchCheckpointRow = __Infer<typeof MatchCheckpointRow>;

export const MatchEconomyRow = __t.object("MatchEconomyRow", {
  matchId: __t.string(),
  woodJson: __t.string(),
  harvestTilesJson: __t.string(),
  updatedTick: __t.u32(),
});
export type MatchEconomyRow = __Infer<typeof MatchEconomyRow>;

export const MatchEngagementRow = __t.object("MatchEngagementRow", {
  id: __t.string(),
  matchId: __t.string(),
  unitAId: __t.string(),
  unitBId: __t.string(),
  tickStarted: __t.u32(),
  tickEnded: __t.u32(),
  naturalDisengageCounter: __t.u32(),
  chargeAppliedA: __t.bool(),
  chargeAppliedB: __t.bool(),
  ticksActive: __t.u32(),
  outcome: __t.string(),
  directionOnA: __t.string(),
  directionOnB: __t.string(),
  totalDamageAToB: __t.f64(),
  totalDamageBToA: __t.f64(),
  totalMoraleAToB: __t.f64(),
  totalMoraleBToA: __t.f64(),
  frontLocked: __t.bool(),
  recentDamageAToB: __t.array(__t.f64()),
  recentDamageBToA: __t.array(__t.f64()),
});
export type MatchEngagementRow = __Infer<typeof MatchEngagementRow>;

export const MatchEventRow = __t.object("MatchEventRow", {
  rowId: __t.u64(),
  matchId: __t.string(),
  tick: __t.u32(),
  eventType: __t.string(),
  unitId: __t.option(__t.string()),
  targetId: __t.option(__t.string()),
  unitAId: __t.option(__t.string()),
  unitBId: __t.option(__t.string()),
  unitName: __t.option(__t.string()),
  unitAName: __t.option(__t.string()),
  unitBName: __t.option(__t.string()),
  armyIndex: __t.option(__t.u32()),
  structureIndex: __t.option(__t.u32()),
  team: __t.option(__t.u32()),
  previousTeam: __t.option(__t.u32()),
  orderType: __t.option(__t.string()),
  friendlyFire: __t.option(__t.bool()),
  bonus: __t.option(__t.f64()),
});
export type MatchEventRow = __Infer<typeof MatchEventRow>;

export const MatchHandoffRequestRow = __t.object("MatchHandoffRequestRow", {
  matchId: __t.string(),
  startPacketJson: __t.string(),
  requestedAt: __t.timestamp(),
});
export type MatchHandoffRequestRow = __Infer<typeof MatchHandoffRequestRow>;

export const MatchHostRow = __t.object("MatchHostRow", {
  matchId: __t.string(),
  hostPlayerId: __t.string(),
  hostIdentity: __t.identity(),
  claimedAt: __t.timestamp(),
});
export type MatchHostRow = __Infer<typeof MatchHostRow>;

export const MatchMessengerRow = __t.object("MatchMessengerRow", {
  id: __t.string(),
  matchId: __t.string(),
  sourceUnitId: __t.string(),
  armyIndex: __t.u32(),
  x: __t.f64(),
  y: __t.f64(),
  targetUnitId: __t.string(),
  targetX: __t.f64(),
  targetY: __t.f64(),
  speed: __t.f64(),
  delivered: __t.bool(),
  cancelled: __t.bool(),
  intercepted: __t.bool(),
  orderType: __t.string(),
  orderJson: __t.string(),
  orderQueueJson: __t.string(),
});
export type MatchMessengerRow = __Infer<typeof MatchMessengerRow>;

export const MatchProjectileRow = __t.object("MatchProjectileRow", {
  id: __t.string(),
  matchId: __t.string(),
  sourceUnitId: __t.string(),
  targetUnitId: __t.string(),
  damage: __t.f64(),
  x: __t.f64(),
  y: __t.f64(),
  vx: __t.f64(),
  vy: __t.f64(),
  ticksAlive: __t.u32(),
  maxTicks: __t.u32(),
  teamIndex: __t.u32(),
  projectileType: __t.string(),
  flightTicks: __t.u32(),
});
export type MatchProjectileRow = __Infer<typeof MatchProjectileRow>;

export const MatchRow = __t.object("MatchRow", {
  id: __t.string(),
  mapName: __t.string(),
  phase: __t.string(),
  tick: __t.u32(),
  hostPlayerId: __t.string(),
  victoryCounter: __t.u32(),
  winner: __t.option(__t.u32()),
  createdAt: __t.timestamp(),
  armyBudget: __t.u32(),
  maxArmySize: __t.u32(),
  mode: __t.option(__t.string()),
  ruleset: __t.option(__t.string()),
  season: __t.option(__t.string()),
  startTickOffset: __t.u32(),
});
export type MatchRow = __Infer<typeof MatchRow>;

export const MatchStateRow = __t.object("MatchStateRow", {
  matchId: __t.string(),
  stateVersion: __t.u64(),
  eventsJson: __t.string(),
  tickEventsJson: __t.string(),
  capturePointsJson: __t.option(__t.string()),
  structureHpJson: __t.option(__t.string()),
  gateOpenJson: __t.option(__t.string()),
  campsJson: __t.option(__t.string()),
  wallBuildProjectsJson: __t.option(__t.string()),
  runtimeStructuresJson: __t.option(__t.string()),
  woodStockpileJson: __t.option(__t.string()),
  harvestTilesJson: __t.option(__t.string()),
  antGroupsJson: __t.option(__t.string()),
  terrainOverridesJson: __t.option(__t.string()),
  watchtowersJson: __t.option(__t.string()),
});
export type MatchStateRow = __Infer<typeof MatchStateRow>;

export const MatchStructureStateRow = __t.object("MatchStructureStateRow", {
  structureStateId: __t.string(),
  matchId: __t.string(),
  structureIndex: __t.u32(),
  hp: __t.f64(),
  gateOpen: __t.bool(),
  structureType: __t.option(__t.string()),
  material: __t.option(__t.string()),
  x: __t.option(__t.f64()),
  y: __t.option(__t.f64()),
  width: __t.option(__t.f64()),
  height: __t.option(__t.f64()),
  radius: __t.option(__t.f64()),
  ownerTeam: __t.option(__t.u32()),
  maxHp: __t.f64(),
  builtInMatch: __t.bool(),
  builtByArmy: __t.option(__t.u32()),
  builtTick: __t.option(__t.u32()),
  facing: __t.option(__t.f64()),
});
export type MatchStructureStateRow = __Infer<typeof MatchStructureStateRow>;

export const MatchTerrainOverridesRow = __t.object("MatchTerrainOverridesRow", {
  matchId: __t.string(),
  overridesJson: __t.string(),
  updatedTick: __t.u32(),
});
export type MatchTerrainOverridesRow = __Infer<typeof MatchTerrainOverridesRow>;

export const MatchUnitRow = __t.object("MatchUnitRow", {
  id: __t.string(),
  matchId: __t.string(),
  persistentId: __t.option(__t.string()),
  armyIndex: __t.u32(),
  archetype: __t.string(),
  name: __t.string(),
  experience: __t.u32(),
  troopsPercent: __t.f64(),
  skillsJson: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  facing: __t.f64(),
  state: __t.string(),
  stance: __t.string(),
  strength: __t.f64(),
  maxStrength: __t.f64(),
  morale: __t.f64(),
  maxMorale: __t.f64(),
  isGeneral: __t.bool(),
  level: __t.u32(),
  attack: __t.f64(),
  defense: __t.f64(),
  attackSkill: __t.f64(),
  defenseSkill: __t.f64(),
  armor: __t.f64(),
  speed: __t.f64(),
  agility: __t.f64(),
  chargeBonus: __t.f64(),
  bracingBonus: __t.f64(),
  mass: __t.f64(),
  isRanged: __t.bool(),
  rangedAttack: __t.f64(),
  rangedDefense: __t.f64(),
  shield: __t.f64(),
  ammo: __t.u32(),
  maxAmmo: __t.u32(),
  fireRateTicks: __t.u32(),
  fireArcHalfAngle: __t.f64(),
  canFireWhileMoving: __t.bool(),
  rangedAccuracy: __t.f64(),
  projectileCount: __t.u32(),
  projectileType: __t.string(),
  category: __t.string(),
  symbol: __t.string(),
  engagementIds: __t.string(),
  currentOrderJson: __t.option(__t.string()),
  pendingOrderJson: __t.option(__t.string()),
  orderQueueJson: __t.string(),
  targetFacing: __t.option(__t.f64()),
  breakTimer: __t.u32(),
  breakTargetEngagementId: __t.option(__t.string()),
  routeTimer: __t.u32(),
  recoveryTimer: __t.u32(),
  routeDirection: __t.f64(),
  routePhase: __t.u32(),
  retreatTargetX: __t.option(__t.f64()),
  retreatTargetY: __t.option(__t.f64()),
  lastPositionX: __t.option(__t.f64()),
  lastPositionY: __t.option(__t.f64()),
  chargeDistanceAccumulated: __t.f64(),
  suppressed: __t.bool(),
  suppressionHitsJson: __t.string(),
  suppressionClearTimer: __t.u32(),
  followMode: __t.bool(),
  fireCooldown: __t.u32(),
  fireTargetId: __t.option(__t.string()),
  volleyRemaining: __t.u32(),
  volleyTargetId: __t.option(__t.string()),
  rangedStance: __t.string(),
  fireRange: __t.f64(),
  visionRange: __t.f64(),
  reinforcedSides: __t.u32(),
  chainFrontUnitId: __t.option(__t.string()),
  chainRearUnitId: __t.option(__t.string()),
  idleStance: __t.string(),
  guardPointX: __t.option(__t.f64()),
  guardPointY: __t.option(__t.f64()),
  guardRadius: __t.f64(),
  guardTargetId: __t.option(__t.string()),
  aggressiveTargetId: __t.option(__t.string()),
  rankLevel: __t.u32(),
  matchDamageDealt: __t.f64(),
  matchKills: __t.u32(),
  matchRoutsCaused: __t.u32(),
  matchTicksEngaged: __t.u32(),
  stanceCooldownTicks: __t.u32(),
  hasPendingOrder: __t.bool(),
  currentOrderType: __t.string(),
  fatigue: __t.f64(),
  fatigueBuildupMultiplier: __t.f64(),
  fatigueRecoveryMultiplier: __t.f64(),
  fireAtWill: __t.bool(),
  formationShape: __t.option(__t.string()),
  perSoldierArea: __t.f64(),
  qualityTier: __t.u32(),
  shockResistance: __t.f64(),
  troopsMax: __t.u32(),
  troopsAlive: __t.u32(),
  troopKills: __t.u32(),
  builderEnabled: __t.bool(),
  builderSeeking: __t.bool(),
  attackSpeed: __t.u8(),
  meleeCooldown: __t.u32(),
  squadId: __t.option(__t.string()),
  squadSize: __t.u32(),
  isCaptain: __t.bool(),
  captainUnitId: __t.option(__t.string()),
  testudoTimer: __t.u32(),
  phalanxTimer: __t.u32(),
  coordinatedChargeTimer: __t.u32(),
  huntSpotTimer: __t.u32(),
  panicCount: __t.u32(),
});
export type MatchUnitRow = __Infer<typeof MatchUnitRow>;

export const MatchWallBuildProjectsRow = __t.object("MatchWallBuildProjectsRow", {
  matchId: __t.string(),
  projectsJson: __t.string(),
  updatedTick: __t.u32(),
});
export type MatchWallBuildProjectsRow = __Infer<typeof MatchWallBuildProjectsRow>;

export const MatchWorkerEndpointRow = __t.object("MatchWorkerEndpointRow", {
  rowId: __t.u64(),
  matchId: __t.string(),
  playerId: __t.string(),
  endpointUrl: __t.string(),
  clientToken: __t.string(),
  registeredAt: __t.timestamp(),
});
export type MatchWorkerEndpointRow = __Infer<typeof MatchWorkerEndpointRow>;

export const ModuleAdminRow = __t.object("ModuleAdminRow", {
  key: __t.string(),
  ownerIdentity: __t.identity(),
});
export type ModuleAdminRow = __Infer<typeof ModuleAdminRow>;

export const ModuleRuntimeConfigRow = __t.object("ModuleRuntimeConfigRow", {
  id: __t.u32(),
  simulationDisabled: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type ModuleRuntimeConfigRow = __Infer<typeof ModuleRuntimeConfigRow>;

export const MyArmyFormationRow = __t.object("MyArmyFormationRow", {
  id: __t.string(),
  armyId: __t.string(),
  name: __t.string(),
  slots: __t.string(),
  createdAt: __t.timestamp(),
});
export type MyArmyFormationRow = __Infer<typeof MyArmyFormationRow>;

export const MyArmyGroupRow = __t.object("MyArmyGroupRow", {
  id: __t.string(),
  armyId: __t.string(),
  groupNumber: __t.u32(),
  name: __t.string(),
  unitIds: __t.string(),
});
export type MyArmyGroupRow = __Infer<typeof MyArmyGroupRow>;

export const MyArmyRow = __t.object("MyArmyRow", {
  id: __t.string(),
  name: __t.string(),
  marchOrder: __t.string(),
  createdAt: __t.timestamp(),
});
export type MyArmyRow = __Infer<typeof MyArmyRow>;

export const MyArmyUnitRow = __t.object("MyArmyUnitRow", {
  id: __t.string(),
  armyId: __t.string(),
  archetype: __t.string(),
  customName: __t.string(),
  slotIndex: __t.u32(),
  isGeneral: __t.bool(),
  level: __t.u32(),
  experience: __t.u32(),
  troopsPercent: __t.f64(),
  kills: __t.u32(),
  battlesSurvived: __t.u32(),
  skills: __t.string(),
});
export type MyArmyUnitRow = __Infer<typeof MyArmyUnitRow>;

export const MyCampaignArmyRow = __t.object("MyCampaignArmyRow", {
  id: __t.string(),
  playerId: __t.string(),
  worldId: __t.string(),
  persistentArmyId: __t.string(),
  name: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  destinationX: __t.option(__t.f64()),
  destinationY: __t.option(__t.f64()),
  status: __t.string(),
  currentCityId: __t.option(__t.string()),
  activeBattleId: __t.option(__t.string()),
  speedPerSecond: __t.f64(),
  updatedAt: __t.timestamp(),
});
export type MyCampaignArmyRow = __Infer<typeof MyCampaignArmyRow>;

export const MyCampaignPlayerRow = __t.object("MyCampaignPlayerRow", {
  playerId: __t.string(),
  worldId: __t.string(),
  playerName: __t.string(),
  joinedAt: __t.timestamp(),
  lastSeenAt: __t.timestamp(),
});
export type MyCampaignPlayerRow = __Infer<typeof MyCampaignPlayerRow>;

export const MyCampaignRecruitmentRow = __t.object("MyCampaignRecruitmentRow", {
  rowId: __t.u64(),
  playerId: __t.string(),
  worldId: __t.string(),
  cityId: __t.string(),
  armyId: __t.string(),
  archetype: __t.string(),
  count: __t.u32(),
  ticksRemaining: __t.u32(),
  status: __t.string(),
  createdAt: __t.timestamp(),
});
export type MyCampaignRecruitmentRow = __Infer<typeof MyCampaignRecruitmentRow>;

export const MyCampaignResourceRow = __t.object("MyCampaignResourceRow", {
  playerId: __t.string(),
  worldId: __t.string(),
  gold: __t.u32(),
  manpower: __t.u32(),
  supplies: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type MyCampaignResourceRow = __Infer<typeof MyCampaignResourceRow>;

export const MyConquestChallengeRow = __t.object("MyConquestChallengeRow", {
  id: __t.string(),
  ruleset: __t.string(),
  territoryId: __t.string(),
  challengerPlayerId: __t.string(),
  defenderPlayerId: __t.string(),
  status: __t.string(),
  sourceMatchId: __t.option(__t.string()),
  challengeMatchId: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  resolvedAt: __t.option(__t.timestamp()),
});
export type MyConquestChallengeRow = __Infer<typeof MyConquestChallengeRow>;

export const MyConquestCustomUnitTemplateRow = __t.object("MyConquestCustomUnitTemplateRow", {
  id: __t.string(),
  playerId: __t.string(),
  ruleset: __t.string(),
  culture: __t.string(),
  displayName: __t.string(),
  meleeWeapon: __t.string(),
  shield: __t.string(),
  armor: __t.string(),
  rangedWeapon: __t.string(),
  mount: __t.string(),
  training: __t.string(),
  weaponTrainingRank: __t.u32(),
  shieldTrainingRank: __t.u32(),
  formationTrainingRank: __t.u32(),
  enduranceTrainingRank: __t.u32(),
  skirmishingTrainingRank: __t.u32(),
  horsemanshipTrainingRank: __t.u32(),
  fieldcraftTrainingRank: __t.u32(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type MyConquestCustomUnitTemplateRow = __Infer<typeof MyConquestCustomUnitTemplateRow>;

export const MyConquestEventRow = __t.object("MyConquestEventRow", {
  rowId: __t.u64(),
  playerId: __t.string(),
  ruleset: __t.string(),
  eventType: __t.string(),
  territoryId: __t.option(__t.string()),
  challengeId: __t.option(__t.string()),
  matchId: __t.option(__t.string()),
  message: __t.string(),
  createdAt: __t.timestamp(),
});
export type MyConquestEventRow = __Infer<typeof MyConquestEventRow>;

export const MyConquestProfileRow = __t.object("MyConquestProfileRow", {
  id: __t.string(),
  playerId: __t.string(),
  ruleset: __t.string(),
  playerName: __t.string(),
  avatarName: __t.string(),
  avatarStatus: __t.string(),
  selectedStarterTerritoryId: __t.option(__t.string()),
  controlledTerritoryCount: __t.u32(),
  replenishmentRate: __t.f64(),
  unlockedUnitsJson: __t.string(),
  unlockedTechJson: __t.string(),
  culture: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  armyBannerId: __t.option(__t.string()),
  armyColor: __t.option(__t.string()),
  armyMarkerTerritoryId: __t.option(__t.string()),
  armyMarkerX: __t.option(__t.f64()),
  armyMarkerY: __t.option(__t.f64()),
});
export type MyConquestProfileRow = __Infer<typeof MyConquestProfileRow>;

export const MyConquestQueueRow = __t.object("MyConquestQueueRow", {
  rowId: __t.u64(),
  playerId: __t.string(),
  ruleset: __t.string(),
  territoryId: __t.string(),
  status: __t.string(),
  matchedMatchId: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type MyConquestQueueRow = __Infer<typeof MyConquestQueueRow>;

export const MyConquestSavedUnitRow = __t.object("MyConquestSavedUnitRow", {
  id: __t.string(),
  playerId: __t.string(),
  ruleset: __t.string(),
  archetype: __t.string(),
  customName: __t.option(__t.string()),
  level: __t.u32(),
  experience: __t.u32(),
  troopsPercent: __t.f64(),
  kills: __t.u32(),
  battlesSurvived: __t.u32(),
  skillsJson: __t.string(),
});
export type MyConquestSavedUnitRow = __Infer<typeof MyConquestSavedUnitRow>;

export const MyConquestTerritoryRow = __t.object("MyConquestTerritoryRow", {
  id: __t.string(),
  playerId: __t.string(),
  ruleset: __t.string(),
  territoryId: __t.string(),
  name: __t.string(),
  status: __t.string(),
  controlled: __t.bool(),
  isStarter: __t.bool(),
  tier: __t.u32(),
  x: __t.f64(),
  y: __t.f64(),
  battleMapsJson: __t.string(),
  unlockUnitsJson: __t.string(),
  unlockTechJson: __t.string(),
  updatedAt: __t.timestamp(),
});
export type MyConquestTerritoryRow = __Infer<typeof MyConquestTerritoryRow>;

export const MyMatchWorkerEndpointRow = __t.object("MyMatchWorkerEndpointRow", {
  matchId: __t.string(),
  endpointUrl: __t.string(),
  clientToken: __t.string(),
});
export type MyMatchWorkerEndpointRow = __Infer<typeof MyMatchWorkerEndpointRow>;

export const MySessionRow = __t.object("MySessionRow", {
  playerId: __t.string(),
  playerName: __t.string(),
  authenticated: __t.bool(),
  userId: __t.option(__t.string()),
  username: __t.option(__t.string()),
  tier: __t.string(),
});
export type MySessionRow = __Infer<typeof MySessionRow>;

export const MyStandaloneStartPacketRow = __t.object("MyStandaloneStartPacketRow", {
  matchId: __t.string(),
  startPacketJson: __t.string(),
});
export type MyStandaloneStartPacketRow = __Infer<typeof MyStandaloneStartPacketRow>;

export const OrchestratorIdentityRow = __t.object("OrchestratorIdentityRow", {
  key: __t.string(),
  identity: __t.identity(),
  registeredAt: __t.timestamp(),
});
export type OrchestratorIdentityRow = __Infer<typeof OrchestratorIdentityRow>;

export const PaintArmyRow = __t.object("PaintArmyRow", {
  id: __t.string(),
  worldId: __t.string(),
  playerId: __t.string(),
  headX: __t.f64(),
  headY: __t.f64(),
  destinationX: __t.option(__t.f64()),
  destinationY: __t.option(__t.f64()),
  pathJson: __t.string(),
  trailJson: __t.string(),
  unitCount: __t.u32(),
  status: __t.string(),
  speedPerSecond: __t.f64(),
  combatTargetId: __t.option(__t.string()),
  respawnAtTick: __t.option(__t.u64()),
  updatedAt: __t.timestamp(),
});
export type PaintArmyRow = __Infer<typeof PaintArmyRow>;

export const PaintCellRow = __t.object("PaintCellRow", {
  id: __t.string(),
  worldId: __t.string(),
  cellX: __t.u32(),
  cellY: __t.u32(),
  ownerPlayerId: __t.string(),
  updatedTick: __t.u64(),
});
export type PaintCellRow = __Infer<typeof PaintCellRow>;

export const PaintEventRow = __t.object("PaintEventRow", {
  rowId: __t.u64(),
  worldId: __t.string(),
  tick: __t.u64(),
  eventType: __t.string(),
  playerId: __t.option(__t.string()),
  otherPlayerId: __t.option(__t.string()),
  message: __t.string(),
  createdAt: __t.timestamp(),
});
export type PaintEventRow = __Infer<typeof PaintEventRow>;

export const PaintPlayerRow = __t.object("PaintPlayerRow", {
  playerId: __t.string(),
  worldId: __t.string(),
  playerName: __t.string(),
  color: __t.string(),
  bannerId: __t.string(),
  paintedCellCount: __t.u32(),
  joinedAt: __t.timestamp(),
  lastSeenAt: __t.timestamp(),
});
export type PaintPlayerRow = __Infer<typeof PaintPlayerRow>;

export const PaintSettingsRow = __t.object("PaintSettingsRow", {
  id: __t.string(),
  armySpeedPerSecond: __t.f64(),
  updatedAt: __t.timestamp(),
});
export type PaintSettingsRow = __Infer<typeof PaintSettingsRow>;

export const PaintTickScheduleRow = __t.object("PaintTickScheduleRow", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  worldId: __t.string(),
});
export type PaintTickScheduleRow = __Infer<typeof PaintTickScheduleRow>;

export const PaintWorldRow = __t.object("PaintWorldRow", {
  id: __t.string(),
  mapName: __t.string(),
  width: __t.f64(),
  height: __t.f64(),
  cellSize: __t.f64(),
  cols: __t.u32(),
  rows: __t.u32(),
  walkableCount: __t.u32(),
  tick: __t.u64(),
  phase: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PaintWorldRow = __Infer<typeof PaintWorldRow>;

export const PendingOrderRow = __t.object("PendingOrderRow", {
  rowId: __t.u64(),
  matchId: __t.string(),
  playerId: __t.string(),
  armyIndex: __t.u32(),
  action: __t.string(),
  payloadJson: __t.string(),
});
export type PendingOrderRow = __Infer<typeof PendingOrderRow>;

export const PlayerMatchFollowWaypointRow = __t.object("PlayerMatchFollowWaypointRow", {
  waypointId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  armyIndex: __t.u32(),
  ordinal: __t.u32(),
  x: __t.f64(),
  y: __t.f64(),
});
export type PlayerMatchFollowWaypointRow = __Infer<typeof PlayerMatchFollowWaypointRow>;

export const PlayerMatchMetaRow = __t.object("PlayerMatchMetaRow", {
  snapshotId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  armyIndex: __t.u32(),
  tick: __t.u32(),
  phase: __t.string(),
  followActive: __t.bool(),
});
export type PlayerMatchMetaRow = __Infer<typeof PlayerMatchMetaRow>;

export const PlayerRow = __t.object("PlayerRow", {
  id: __t.string(),
  name: __t.string(),
  createdAt: __t.timestamp(),
});
export type PlayerRow = __Infer<typeof PlayerRow>;

export const PlayerVisibilityBitmapRow = __t.object("PlayerVisibilityBitmapRow", {
  bitmapId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  armyIndex: __t.u32(),
  tick: __t.u32(),
  cellSize: __t.f64(),
  cols: __t.u32(),
  rows: __t.u32(),
  rle: __t.byteArray(),
});
export type PlayerVisibilityBitmapRow = __Infer<typeof PlayerVisibilityBitmapRow>;

export const PlayerVisibleEnemyUnitRow = __t.object("PlayerVisibleEnemyUnitRow", {
  visibleUnitId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  unitId: __t.string(),
  armyIndex: __t.u32(),
  archetype: __t.string(),
  name: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  facing: __t.f64(),
  state: __t.string(),
  stance: __t.string(),
  strength: __t.f64(),
  maxStrength: __t.f64(),
  troopsAlive: __t.u32(),
  troopsMax: __t.u32(),
  isGeneral: __t.bool(),
  category: __t.string(),
  symbol: __t.string(),
  level: __t.u32(),
  isRanged: __t.bool(),
  suppressed: __t.bool(),
  followMode: __t.bool(),
  garrisonedIn: __t.option(__t.u32()),
  ammo: __t.option(__t.u32()),
  maxAmmo: __t.option(__t.u32()),
  fireRange: __t.option(__t.f64()),
  rangedStance: __t.option(__t.string()),
  fireAtWill: __t.option(__t.bool()),
  length: __t.f64(),
  width: __t.f64(),
  squadId: __t.option(__t.string()),
  squadSize: __t.u32(),
  kills: __t.u32(),
  xpEarned: __t.u32(),
});
export type PlayerVisibleEnemyUnitRow = __Infer<typeof PlayerVisibleEnemyUnitRow>;

export const PlayerVisibleEngagementRow = __t.object("PlayerVisibleEngagementRow", {
  visibleEngagementId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  engagementId: __t.string(),
  unitAId: __t.string(),
  unitBId: __t.string(),
  tickStarted: __t.u32(),
  ticksActive: __t.u32(),
  directionOnA: __t.string(),
  directionOnB: __t.string(),
  damageAToB: __t.f64(),
  damageBToA: __t.f64(),
  moraleAToB: __t.f64(),
  moraleBToA: __t.f64(),
  outcome: __t.string(),
});
export type PlayerVisibleEngagementRow = __Infer<typeof PlayerVisibleEngagementRow>;

export const PlayerVisibleFriendlyUnitRow = __t.object("PlayerVisibleFriendlyUnitRow", {
  visibleUnitId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  unitId: __t.string(),
  armyIndex: __t.u32(),
  persistentId: __t.option(__t.string()),
  archetype: __t.string(),
  name: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  facing: __t.f64(),
  state: __t.string(),
  stance: __t.string(),
  strength: __t.f64(),
  maxStrength: __t.f64(),
  isGeneral: __t.bool(),
  category: __t.string(),
  symbol: __t.string(),
  level: __t.u32(),
  isRanged: __t.bool(),
  suppressed: __t.bool(),
  followMode: __t.bool(),
  garrisonedIn: __t.option(__t.u32()),
  ammo: __t.option(__t.u32()),
  maxAmmo: __t.option(__t.u32()),
  fireRange: __t.option(__t.f64()),
  rangedStance: __t.option(__t.string()),
  morale: __t.f64(),
  maxMorale: __t.f64(),
  fatigue: __t.f64(),
  reinforcedSides: __t.u32(),
  chainFrontUnitId: __t.option(__t.string()),
  chainRearUnitId: __t.option(__t.string()),
  chainDepth: __t.u32(),
  chainSize: __t.u32(),
  hasPendingOrder: __t.bool(),
  currentOrderType: __t.option(__t.string()),
  experience: __t.u32(),
  idleStance: __t.string(),
  guardPointX: __t.option(__t.f64()),
  guardPointY: __t.option(__t.f64()),
  guardRadius: __t.f64(),
  visionRange: __t.f64(),
  moveTargetX: __t.option(__t.f64()),
  moveTargetY: __t.option(__t.f64()),
  moveTargetFacing: __t.option(__t.f64()),
  fireAtWill: __t.option(__t.bool()),
  formationShape: __t.option(__t.string()),
  length: __t.f64(),
  width: __t.f64(),
  troopsAlive: __t.u32(),
  troopsMax: __t.u32(),
  builderEnabled: __t.bool(),
  squadId: __t.option(__t.string()),
  squadSize: __t.u32(),
  isCaptain: __t.bool(),
  captainUnitId: __t.option(__t.string()),
  kills: __t.u32(),
  xpEarned: __t.u32(),
});
export type PlayerVisibleFriendlyUnitRow = __Infer<typeof PlayerVisibleFriendlyUnitRow>;

export const PlayerVisibleMessengerRow = __t.object("PlayerVisibleMessengerRow", {
  visibleMessengerId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  messengerId: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  targetUnitId: __t.string(),
  orderType: __t.string(),
});
export type PlayerVisibleMessengerRow = __Infer<typeof PlayerVisibleMessengerRow>;

export const PlayerVisibleProjectileRow = __t.object("PlayerVisibleProjectileRow", {
  visibleProjectileId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  projectileId: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  vx: __t.f64(),
  vy: __t.f64(),
  teamIndex: __t.u32(),
  projectileType: __t.string(),
  progress: __t.f64(),
});
export type PlayerVisibleProjectileRow = __Infer<typeof PlayerVisibleProjectileRow>;

export const PlayerVisibleProjectileV2Row = __t.object("PlayerVisibleProjectileV2Row", {
  visibleProjectileId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  projectileId: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  vx: __t.f64(),
  vy: __t.f64(),
  teamIndex: __t.u32(),
  projectileType: __t.string(),
  progress: __t.f64(),
});
export type PlayerVisibleProjectileV2Row = __Infer<typeof PlayerVisibleProjectileV2Row>;

export const PlayerVisibleProjectileV3Row = __t.object("PlayerVisibleProjectileV3Row", {
  visibleProjectileId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  projectileId: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  vx: __t.f64(),
  vy: __t.f64(),
  teamIndex: __t.u32(),
  projectileType: __t.string(),
  progress: __t.f64(),
  sourceUnitId: __t.option(__t.string()),
});
export type PlayerVisibleProjectileV3Row = __Infer<typeof PlayerVisibleProjectileV3Row>;

export const PlayerVisibleUnitOrderQueueRow = __t.object("PlayerVisibleUnitOrderQueueRow", {
  orderRowId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  unitId: __t.string(),
  ordinal: __t.u32(),
  orderType: __t.string(),
  targetX: __t.option(__t.f64()),
  targetY: __t.option(__t.f64()),
  facing: __t.option(__t.f64()),
  targetUnitId: __t.option(__t.string()),
});
export type PlayerVisibleUnitOrderQueueRow = __Infer<typeof PlayerVisibleUnitOrderQueueRow>;

export const PlayerVisibleUnitPathWaypointRow = __t.object("PlayerVisibleUnitPathWaypointRow", {
  waypointId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  unitId: __t.string(),
  ordinal: __t.u32(),
  x: __t.f64(),
  y: __t.f64(),
});
export type PlayerVisibleUnitPathWaypointRow = __Infer<typeof PlayerVisibleUnitPathWaypointRow>;

export const PlayerVisibleUnitSkillRow = __t.object("PlayerVisibleUnitSkillRow", {
  skillId: __t.string(),
  playerId: __t.string(),
  matchId: __t.string(),
  unitId: __t.string(),
  ordinal: __t.u32(),
  skillName: __t.string(),
});
export type PlayerVisibleUnitSkillRow = __Infer<typeof PlayerVisibleUnitSkillRow>;

export const SkirmishLobbyMatchRow = __t.object("SkirmishLobbyMatchRow", {
  matchId: __t.string(),
  mapName: __t.string(),
  phase: __t.string(),
  hostPlayerId: __t.string(),
  hostPlayerName: __t.string(),
  playerNames: __t.string(),
  playerCount: __t.u32(),
  armyBudget: __t.u32(),
  maxArmySize: __t.u32(),
  ruleset: __t.string(),
  season: __t.string(),
  createdAt: __t.timestamp(),
});
export type SkirmishLobbyMatchRow = __Infer<typeof SkirmishLobbyMatchRow>;

export const StandaloneStartPacketRow = __t.object("StandaloneStartPacketRow", {
  matchId: __t.string(),
  hostPlayerId: __t.string(),
  startPacketJson: __t.string(),
  capturedAt: __t.timestamp(),
});
export type StandaloneStartPacketRow = __Infer<typeof StandaloneStartPacketRow>;

export const TickScheduleRow = __t.object("TickScheduleRow", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  matchId: __t.string(),
});
export type TickScheduleRow = __Infer<typeof TickScheduleRow>;

